import { render } from "./SideTab.vue?vue&type=template&id=abf7588e&scoped=true"
import script from "./SideTab.vue?vue&type=script&lang=js"
export * from "./SideTab.vue?vue&type=script&lang=js"

import "./SideTab.vue?vue&type=style&index=0&id=abf7588e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf7588e"]])

export default __exports__